import KunLoading83 from './src/index'

KunLoading83.install = function (Vue) {
	Vue.component(KunLoading83.name, KunLoading83);
}

export default KunLoading83;
